export const addSign = (requestUrl: string | null | undefined) => {
  if (!requestUrl) return ''
  return requestUrl.startsWith('@') ? requestUrl : `@${requestUrl}`
}

export const removeSign = (requestUrl: string | null | undefined) => {
  if (!requestUrl) return ''
  return requestUrl.startsWith('@') ? requestUrl.slice(1) : requestUrl
}
